export const getImageUrl = (src: string) => {
  if (src) {
    return `${process.env.REACT_APP_API_BASE_URL}/${src}`
  }

  return '';
};
